// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1330":"2ae9cb0aa13d36f7","2888":"ed6c98f7c8dce3d6"}[chunkId] + ".css";
};